import { PropsWithChildren } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppState, Auth0Provider } from '@auth0/auth0-react';
import { Toaster } from 'sonner';

import { ENVIRONMENT } from '@/constants';
import { auth0Scope } from '@flintmint/web-shared/hooks/use-auth-user';
import { FirebaseAuthProvider } from './firebase-provider';

export const AppProvider = (props: PropsWithChildren) => {
  const navigate = useNavigate();

  const onRedirectCallback = (appState?: AppState) => {
    navigate(appState?.returnTo || window.location.pathname);
  };

  return (
    <Auth0Provider
      domain={ENVIRONMENT.VITE_APP_AUTH0_DOMAIN}
      clientId={ENVIRONMENT.VITE_ADMIN_AUTH0_CLIENT_ID}
      authorizationParams={{
        scope: auth0Scope,
        prompt: 'select_account',
        audience: ENVIRONMENT.VITE_APP_AUTH0_AUDIENCE,
        redirect_uri: window.location.origin,
      }}
      useRefreshTokens
      cacheLocation="localstorage"
      onRedirectCallback={onRedirectCallback}
    >
      <FirebaseAuthProvider>{props.children}</FirebaseAuthProvider>
      <Toaster position="top-center" offset={{ top: 24 }} visibleToasts={3} richColors duration={4000} />
    </Auth0Provider>
  );
};
